import { Link } from "@frontend/lib/link";
import { BrandLogo } from "@frontend/components/brand-logo";
import { SITE_SECTIONS } from "@frontend/components/site/links";
import { StoreBadges } from "@frontend/components/site/store-badges";
import { branding } from "@creators/backend/lib/config";

const COLUMNS = [
  {
    heading: "Product",
    links: SITE_SECTIONS,
  },
  {
    heading: "Account",
    links: [
      { label: "Create your collab link", href: "/login" },
      { label: "Your collabs", href: "/collabs" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
      { label: "Delete account", href: "/delete-account" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="mkt border-t border-ink/10 bg-white">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 pb-[max(3rem,env(safe-area-inset-bottom))]">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_10rem_10rem_10rem] lg:gap-16">
          <div className="max-w-sm">
            <Link href="/" className="inline-flex items-center" aria-label="SendCollab">
              <BrandLogo wordmarkAlways />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-ink/55">
              Collaborations for video creators, run end to end: one link for inbound offers, terms
              agreed in writing, and every payment confirmed by both sides.
            </p>
            {/* Desktop only: on a phone the badges crowd the footer. */}
            <div className="hidden sm:block">
              <StoreBadges className="mt-5" />
            </div>
          </div>

          {COLUMNS.map((column) => (
            <nav key={column.heading} aria-label={column.heading}>
              <h2 className="text-xs font-semibold tracking-[0.14em] text-ink/40 uppercase">
                {column.heading}
              </h2>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-ink/60 transition hover:text-ink"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className="mt-12 border-t border-ink/10 pt-6 text-xs text-ink/40">
          © {new Date().getFullYear()} {branding.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
